import { render, staticRenderFns } from "./LayoutSubNav.vue?vue&type=template&id=7b0513cb&scoped=true"
import script from "./LayoutSubNav.vue?vue&type=script&lang=js"
export * from "./LayoutSubNav.vue?vue&type=script&lang=js"
import style0 from "./LayoutSubNav.vue?vue&type=style&index=0&id=7b0513cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0513cb",
  null
  
)

export default component.exports